<template>
  <Modal :title="$t('ASK_FOR_OFFER')">
    <template #content>
      <div class="modal" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal__header mobile--hide">
          <p>{{ $t('ASK_FOR_OFFER') }}</p>
        </div>
        <div class="modal__actions">
          <button
            type="button"
            class="btn btn-close mobile--hide"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="25"
              viewBox="0 0 26 25"
              fill="none">
              <path
                d="M2 23L23.9203 1.07969"
                stroke="white"
                stroke-width="3"></path>
              <path
                d="M24 23L2.07969 1.07969"
                stroke="white"
                stroke-width="3"></path>
            </svg>
          </button>
          <button
            type="button"
            class="btn btn-close mobile--show"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="15"
              viewBox="0 0 26 25"
              fill="none">
              <path
                d="M2 23L23.9203 1.07969"
                stroke="white"
                stroke-width="3"></path>
              <path
                d="M24 23L2.07969 1.07969"
                stroke="white"
                stroke-width="3"></path>
            </svg>
          </button>
        </div>
        <div class="modal__content">
          <div class="modal-content">
            <div class="modal__content--body">
              <div class="content__body--img mobile--hide">
                <AvatarComponent :model-value="props.offerData?.image" />
              </div>
              <div class="content__body">
                <p>{{ $t('ASK_FOR_PRODUCT_OR_SERVICE') }}</p>
                <div class="content__body--form">
                  <textarea
                    v-model="mailContent"
                    :placeholder="$t('ASK_FOR_OFFER__PLACEHOLDER')"
                    class="form__text"
                    name="textInput"></textarea>
                  <button
                    class="btn btn-primary"
                    style="width: 100%; gap: 15px"
                    @click="send()">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none">
                      <mask
                        id="mask0_1897_5296"
                        style="mask-type: luminance"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="28"
                        height="28">
                        <path d="M27.5 0.5H0.5V27.5H27.5V0.5Z" fill="white" />
                      </mask>
                      <g mask="url(#mask0_1897_5296)">
                        <mask
                          id="mask1_1897_5296"
                          style="mask-type: luminance"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="28"
                          height="28">
                          <path
                            d="M0.5 0.500004H27.5V27.5H0.5V0.500004Z"
                            fill="white" />
                        </mask>
                        <g mask="url(#mask1_1897_5296)">
                          <path
                            d="M6.08984 13.0977C6.08984 10.7095 8.02588 8.77344 10.4141 8.77344C12.8022 8.77344 14.7383 10.7095 14.7383 13.0977C14.7383 15.4858 12.8022 17.4219 10.4141 17.4219C8.02588 17.4219 6.08984 15.4858 6.08984 13.0977Z"
                            stroke="white"
                            stroke-width="2.34375"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M12.8416 26.4453H3.66585C2.23522 26.4453 1.2195 25.0513 1.65756 23.6894C2.82125 20.0712 6.38778 17.453 10.3927 17.453C12.3033 17.453 14.0746 18.0488 15.5311 19.0647"
                            stroke="white"
                            stroke-width="2.34375"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M17.0078 5.87891C17.0078 3.49073 18.9438 1.55469 21.332 1.55469C23.7202 1.55469 25.6562 3.49073 25.6562 5.87891C25.6562 8.26709 23.7202 10.2031 21.332 10.2031C18.9438 10.2031 17.0078 8.26709 17.0078 5.87891Z"
                            stroke="white"
                            stroke-width="2.34375"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M14.7734 13.0508C16.4127 11.3169 18.7345 10.235 21.309 10.235C23.2194 10.235 24.9907 10.8308 26.4472 11.8467"
                            stroke="white"
                            stroke-width="2.34375"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M22.4922 26.4453V18.5352"
                            stroke="white"
                            stroke-width="2.34375"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M26.4453 22.4902H18.5352"
                            stroke="white"
                            stroke-width="2.34375"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                        </g>
                      </g>
                    </svg>
                    <p>{{ $t('SEND_AN_INQUIRY') }}</p>
                  </button>
                </div>
              </div>
            </div>
            <div class="modal__content--footer">
              <p>
                {{ $t('SEND_AN_INQUIRY__CONSENT') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup lang="ts">
import ModalProfileAskForOfferSuccess from '~/components/Modal/Profile/AskForOfferSuccess.vue'
import { useCompanyStore } from '~/stores/companyStore'
import { useModal } from 'vue-final-modal'
import AvatarComponent from '~/components/shared/AvatarComponent.vue'
import { useAuthFetch } from '~/composables/useAuthFetch'

const mailContent = ref('')

const emit = defineEmits<{
  (e: 'update:model-value', modelValue: string): void
  (e: 'closed'): void
}>()

const props = defineProps({
  profileId: {
    type: Number || null,
    default: null,
  },
  companyId: {
    type: Number || null,
    default: null,
  },
  offerData: {
    type: Object,
    default: () => ({}),
  },
})
const { t: $t } = useI18n()

const store = useCompanyStore()
const { $toast } = useNuxtApp()

let sellerData: any

if (props.profileId !== null) {
  sellerData = store.getSellerData({
    companyId: props.companyId,
    sellerId: props.profileId,
  })
} else {
  sellerData = null
}

const close = () => {
  emit('closed')
}

const { userInfo } = storeToRefs(useUserStore())

async function send() {
  await useAuthFetch('/marketplace/request-offer', {
    method: 'POST',
    body: {
      email: props.offerData?.email ?? '',
      body: `${mailContent.value}<br><br><hr>{{ $t('COMMON.USER_EMAIL'}}: ${userInfo.value?.email}`,
    },
    onResponse({ response }) {
      if (response.status === 201) {
        $toast.info($t('MESSAGE_SUCCESS'))
        const { open } = useModal({
          component: ModalProfileAskForOfferSuccess,
        })

        open()
        emit('closed')
      }
    },
  })
}
</script>
<style lang="scss" scoped>
.modal {
  grid-template-rows: initial;
  grid-template-columns: 1fr 3fr;
  max-width: 1080px;
  grid-template-areas:
    'header header'
    'content content';
}
</style>
